import { ReactNode } from 'react'

import Tooltip from '~/core/Tooltip'
import Text from '~/core/Text'
import middleTruncate, { tailTruncate } from '~/lib/middleTruncate'

const DEFAULT_MAX_LENGTH = 27
const baseStyle = {
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    width: '100%',
}
const overlayStyle = {
    wordWrap: 'break-word' as const,
}

type TruncatedTextPropsType = {
    body?: string
    children?: string | ReactNode | Function
    maxLength?: number
    style?: { [key: string]: any }
    cssOnly?: boolean
    tailTruncated?: boolean
    tooltipPlacement?:
        | 'top'
        | 'left'
        | 'right'
        | 'bottom'
        | 'topLeft'
        | 'topRight'
        | 'bottomLeft'
        | 'bottomRight'
        | 'leftTop'
        | 'leftBottom'
        | 'rightTop'
        | 'rightBottom'
}

export default function TruncatedText(props: TruncatedTextPropsType) {
    const {
        body,
        children,
        maxLength = DEFAULT_MAX_LENGTH,
        style,
        cssOnly,
        tooltipPlacement,
        tailTruncated = false,
        ...newProps
    } = props
    const _text = typeof children === 'string' ? children : body

    if (!_text) {
        return null
    }

    const truncatedText = tailTruncated
        ? tailTruncate(_text, maxLength)
        : middleTruncate(_text, maxLength)
    const truncated = cssOnly ? _text : truncatedText

    return (
        <Tooltip
            title={_text}
            overlayStyle={overlayStyle}
            placement={tooltipPlacement}
        >
            {typeof children === 'function' ? (
                children({
                    truncated,
                    body: _text,
                })
            ) : (
                <Text {...newProps} style={{ ...baseStyle, ...style }}>
                    {truncated}
                </Text>
            )}
        </Tooltip>
    )
}
